import { ChakraProvider, theme } from '@chakra-ui/react';
import React from 'react';
import App from './App';
import ReactDOM from 'react-dom/client';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>

      <App/>
    </ChakraProvider>
  </React.StrictMode>
);

export const Server='https://api.coingecko.com/api/v3'

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

